export function normalizeIndustries(source = {}, options = {}) {
	// A missing profile is passed as null. Default parameters only replace
	// undefined, so the session-cleared profile must be handled explicitly.
	if (source == null) {
		return []
	}

	const industries = []

	if (Array.isArray(source.industries)) {
		if (source.industries.length) {
			industries.push(...source.industries)
		} else if (!options.fallbackOnEmptyRelations) {
			return []
		}
	}

	if (!industries.length && Array.isArray(source.industry)) {
		industries.push(...source.industry)
	} else if (
		!industries.length &&
		source.industry &&
		typeof source.industry === 'object'
	) {
		industries.push(source.industry)
	}

	return industries.filter(Boolean).reduce((unique, industry) => {
		if (!industry || industry.id == null) {
			return unique
		}

		if (!unique.some(item => item.id == industry.id)) {
			unique.push(industry)
		}

		return unique
	}, [])
}

export function getIndustryIds(source = {}, options = {}) {
	if (source == null) {
		return []
	}

	if (Array.isArray(source.industry_ids)) {
		const industryIds = source.industry_ids.filter(
			id => id !== null && id !== undefined
		)

		if (industryIds.length || options.preserveExplicitEmpty) {
			return industryIds
		}
	}

	const relationIds = normalizeIndustries(source, options).map(
		industry => industry.id
	)

	if (relationIds.length) {
		return relationIds
	}

	if (Array.isArray(source.industries) && !options.fallbackOnEmptyRelations) {
		return []
	}

	return source.industry_id ? [source.industry_id] : []
}

export function orderIndustriesByJobMatch(industries = [], jobIndustry = null) {
	const normalized = normalizeIndustries({ industries })
	const jobIndustryId = jobIndustry && jobIndustry.id

	if (!jobIndustryId) {
		return normalized
	}

	return [...normalized].sort((a, b) => {
		const aMatches = a.id == jobIndustryId ? 1 : 0
		const bMatches = b.id == jobIndustryId ? 1 : 0

		return bMatches - aMatches
	})
}

export function industryMatchesJob(industries = [], jobIndustry = null) {
	if (!jobIndustry || jobIndustry.id == null) {
		return false
	}

	return normalizeIndustries({ industries }).some(
		industry => industry.id == jobIndustry.id
	)
}

export function getIndustryName(industry, localeColumn = 'name') {
	if (!industry) {
		return ''
	}

	return industry[localeColumn] || industry.name || industry.name_en || ''
}

export function getIndustryNamesText(
	industries = [],
	localeColumn = 'name',
	separator = ', '
) {
	return normalizeIndustries({ industries })
		.map(industry => getIndustryName(industry, localeColumn))
		.filter(Boolean)
		.join(separator)
}

export function getCompactIndustryDisplay(
	industries = [],
	localeColumn = 'name',
	visibleCount = 1
) {
	const normalized = normalizeIndustries({ industries })
	const visible = normalized.slice(0, visibleCount)
	const hidden = normalized.slice(visible.length)
	const hiddenCount = Math.max(normalized.length - visible.length, 0)
	const labels = normalized
		.map(industry => getIndustryName(industry, localeColumn))
		.filter(Boolean)
	const items = hidden
		.map(industry => getIndustryName(industry, localeColumn))
		.filter(Boolean)

	return {
		visible,
		hiddenCount,
		items,
		label: labels.join(', '),
		tooltip: items.join(', ')
	}
}
